import { AxiosRequestConfig } from "axios";

export const BaseHeaders: AxiosRequestConfig = {
  headers: {
    "Access-Control-Allow-Origin": "*",
    "Ocp-Apim-Subscription-Key": (window as any).currentEnvironment
      .REACT_APP_API_GATEWAY_AUTHORIZATION_KEY,
  },
};

export const AxiosFileUploadRequestConfig = (
  jwt: string
): AxiosRequestConfig => ({
  headers: {
    ...BaseHeaders.headers,
    "Content-Type": "multipart/form-data",
    "Cache-Control": "no-cache",
    Authorization: `Bearer ${jwt}`,
  },
});

export const axiosRequestConfig = (jwt: string): AxiosRequestConfig => ({
  headers: {
    ...BaseHeaders.headers,
    Authorization: `Bearer ${jwt}`,
  },
});

export const BaseUrl = `${
  (window as any).currentEnvironment.REACT_APP_API_GATEWAY_BASE_URL
}`;

export const BaseMembershipUrl = `${BaseUrl}/${
  (window as any).currentEnvironment.REACT_APP_API_MEMBERSHIP_URL
}`;

export const BaseAdyenUrl = `${BaseUrl}/${
  (window as any).currentEnvironment.REACT_APP_API_ADYEN_URL
}`;

export const ProfileUrl = `${BaseUrl}/${
  (window as any).currentEnvironment.REACT_APP_API_PROFILE_URL
}`;

export const PaymentMethodUrl: string = `${BaseAdyenUrl}/paymentMethod`;

export const PaymentUrl: string = `${BaseAdyenUrl}/payments`;

export const PaymentDetailsUrl: string = `${BaseAdyenUrl}/paymentDetails`;

export default {};
